// SVG-графіка сторінки статистики. Кольори беруться з теми через currentColor / CSS-змінні.

export const HeroArt = () => (
    <svg className="stats-hero-art" viewBox="0 0 320 200" fill="none" aria-hidden="true">
        {/* тактична сітка */}
        <g stroke="currentColor" strokeOpacity="0.12" strokeWidth="1">
            {Array.from({ length: 9 }, (_, i) => <line key={`v${i}`} x1={40 + i * 30} y1="0" x2={40 + i * 30} y2="200" />)}
            {Array.from({ length: 6 }, (_, i) => <line key={`h${i}`} x1="0" y1={20 + i * 32} x2="320" y2={20 + i * 32} />)}
        </g>

        {/* траєкторія кулі */}
        <path d="M0 170 C 70 150, 120 110, 205 100" stroke="#ffc43b" strokeWidth="2" strokeDasharray="2 7" strokeLinecap="round" />
        <circle cx="26" cy="166" r="4" fill="#ffc43b" />

        {/* приціл */}
        <g stroke="currentColor" strokeWidth="3" strokeLinecap="round" transform="translate(205 100)">
            <circle r="62" strokeOpacity="0.35" />
            <circle r="40" />
            <circle r="16" />
            <circle r="3.5" fill="#ff4d4d" stroke="none" />
            <path d="M0 -78v30M0 48v30M-78 0h30M48 0h30" />
        </g>

        {/* мітки дальності */}
        <g fill="currentColor" fillOpacity="0.55" fontSize="10" fontFamily="Montserrat, sans-serif" fontWeight="700">
            <text x="104" y="36">200 м</text>
            <text x="150" y="190">500 м</text>
            <text x="262" y="30">1000 м</text>
        </g>
    </svg>
);

export const CrownIcon = ({ className = "" }: { className?: string }) => (
    <svg className={className} width="30" height="24" viewBox="0 0 24 20" fill="#ffc43b" aria-hidden="true">
        <path d="M2 6l5 4 5-8 5 8 5-4-2 12H4L2 6zm2.6 13.5h14.8V20H4.6v-.5z" />
    </svg>
);

const icon = (children: JSX.Element) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {children}
    </svg>
);

export const SkullIcon = () => icon(
    <>
        <path d="M12 3c-4.4 0-8 3.1-8 7.2 0 2.3 1.1 4.1 3 5.3V19h10v-3.5c1.9-1.2 3-3 3-5.3C20 6.1 16.4 3 12 3z" />
        <circle cx="9" cy="11" r="1.4" />
        <circle cx="15" cy="11" r="1.4" />
        <path d="M10 19v2m4-2v2" />
    </>
);

export const RatioIcon = () => icon(
    <>
        <path d="M5 19L19 5" />
        <circle cx="7" cy="7" r="2.5" />
        <circle cx="17" cy="17" r="2.5" />
    </>
);

export const DistanceIcon = () => icon(
    <>
        <circle cx="12" cy="12" r="8" />
        <circle cx="12" cy="12" r="3" />
        <path d="M12 2v4M12 18v4M2 12h4M18 12h4" />
    </>
);

export const ClockIcon = () => icon(
    <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
    </>
);
